import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type FindProjectCoursesParams = {
  projectId: number;
};

const { useFind: useProjectCourses } = getCRUDHooks({
  entityName: 'projectCourses',
  find: ({ projectId }: FindProjectCoursesParams) =>
    clientApi.getOCClient().helpers.learningContent.projects.getCourses(projectId),
});

export default useProjectCourses;
